import { render, staticRenderFns } from "./Understanding.vue?vue&type=template&id=6bbf6e18&"
import script from "./Understanding.vue?vue&type=script&lang=js&"
export * from "./Understanding.vue?vue&type=script&lang=js&"
import style0 from "./Understanding.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports